<template>
  <gj-modal
      :visible.sync="modalVisible"
      :destroyOnClose="true"
      size="1300_auto">
    <template #header>
      <span>历史成本</span>
    </template>
    <template #content>
      <el-row  type="flex">
        <div>
          <gj-image :src="formData.imageUrl" :size="50"></gj-image>
        </div>
        <div class="cost-history-content flex justify-between">
          <div class="cost-history-title">
            <div style="max-width: 85%; display: inline-block;">
              <span>产品名称:</span>
              <gj-tooltip
                  :content="formData.skuName"
                  :text-line="1"
                  style="display: inline-flex;">
                {{ formData.skuName || '-' }}
              </gj-tooltip>
            </div>
          </div>
          <el-row style="width: 600px;">
            <el-col :span=12 v-if="params.type === 'msku'">
              <div class="cost-history-info">
                <span class="cost-history-label">
                  <gj-tooltip class="value" :text-line="1"
                              :content="formData.msku">MSKU: {{ formData.msku || '-' }}</gj-tooltip>
                </span>
              </div>
            </el-col>
            <el-col :span=12 v-if="params.type === 'sku'">
              <div class="cost-history-info">
                <span class="cost-history-label">
                <gj-tooltip class="value" :text-line="1"
                            :content="formData.sku">SKU: {{ formData.sku || '-' }}</gj-tooltip>
                </span>
              </div>
            </el-col>
            <el-col :span=12>
              <div class="cost-history-info">
                <span class="cost-history-label">
                  <gj-tooltip class="value" :text-line="1"
                              :content="formData.warehouseName">仓库: {{ formData.warehouseName || '-' }}</gj-tooltip>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-row>

        <gj-date-picker
            v-model="dateVal"
            type="monthrange"
            :clearable="false"
            :shortcut="false"
            style="padding: 4px 0 12px;"
        ></gj-date-picker>

        <gj-table
            ref="gjTable"
            :index="false"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :pagination="pagination"
            @page-change="$gjNoticeQuery">
          <template v-slot:monthDate="{row}">
              <div>
                <span style="margin-right: 6px;">{{row.monthDate}}</span>
                <gj-tag v-if="row.status === 0" type="plain" :color="tagColors.gray">未维护</gj-tag>
                <gj-tag v-if="row.status === 1" type="plain" :color="tagColors.orange">手动更新</gj-tag>
                <gj-tag v-if="row.status === 2" type="plain" :color="tagColors.blue">系统更新</gj-tag>
              </div>
          </template>
          <template v-slot:warehouseName="{row}">
            <gj-tooltip class="value" style="flex: 1" :text-line="1" :content="row.warehouseName">
              {{ row.warehouseName }}
            </gj-tooltip>
          </template>
          <template v-slot:purchaseCost="{ row }">
            <template v-if="$permission('financialMonthCost:update')">
              <gj-input
                  v-model="row.purchaseCost"
                  @change="updateCost(row, 'purchaseCost')"
                  placeholder="采购成本"
                  width="150px"
                  v-number.toFixed4
                  maxlength="17"
              >
                <template #prepend>
                  ￥
                </template>
              </gj-input>
            </template>
            <template v-else>
              {{ row.purchaseCost ? '￥' + row.purchaseCost : '-' }}
            </template>
          </template>
          <template v-slot:arrivalCost="{row}">
            <template v-if="$permission('financialMonthCost:update')">
              <gj-input
                  v-model="row.inventoryCost"
                  @change="updateCost(row, 'inventoryCost')"
                  placeholder="到库成本"
                  width="150px"
                  maxlength="17"
                  v-number.toFixed4
              >
                <template #prepend>
                  ￥
                </template>
              </gj-input>
            </template>
            <template v-else>
              {{ row.inventoryCost ? '￥' + row.inventoryCost : '-' }}
            </template>
          </template>
        </gj-table>

    </template>
  </gj-modal>
</template>

<script>
import {batchUpdateFBAMonthCost, getHistoryMonthCostPage, UpdateMonthCost,} from "@/api/finance.js";
import {queryMixin, formRuleMixin, modalMixIn} from "@/minxins";
import {convertToFullDate} from "@/utils/date.util";
import {endOfMonth, startOfMonth, subMonths} from 'date-fns';
import {isMeaningful, isMeaningless} from "@/utils/common";
import { tagColors } from '@/components/tag/tag-colors'

export default {
  name: "cost-center-more-history",
  components: {},
  mixins: [queryMixin, modalMixIn, formRuleMixin],
  props: {
    formData: {
      required: true,
    },
    params: {
      required: true
    }
  },
  watch:{
    dateVal:{
      handler(){
         this.$gjQuery();
      },
    }
  },
  data() {
    return {
      tableData: [],
      columns: [
        {id: 'monthDate', header: '成本时间', field: 'slot:monthDate', minWidth: '155px', default: true},
        {id: 'purchaseCost', header: '采购成本', field: 'slot:purchaseCost', minWidth: '120px', default: true},
        {id: 'arrivalCost', header: '到库成本', field: 'slot:arrivalCost', minWidth: '120px', default: true},
        {id: 'updateUser', header: '更新人', field: 'updateUserName', minWidth: '120px', default: true},
        {id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '155px', default: true},
      ],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      dateVal: [startOfMonth(subMonths(new Date(), 12)), endOfMonth(new Date())],
      loading: false,
      tagColors
    }
  },
  methods: {
    updateCost(row, key) {
      let value = row[key].split('.')[0]+'';
      if(value.length > 8){
        this.$gjMessage.error('请输入正确的数值，保留四位小数');
        return false;
      }
      const reg = /^[0-9]+(.?[0-9]{1,4})?$/;
      if (isMeaningless(row[key]) || (!isNaN(row[key]) && reg.test(row[key]))) {
        let param = {
          id: row.id,
          purchaseCost: isMeaningful(row['purchaseCost']) ? row['purchaseCost'] : 0,
          inventoryCost: isMeaningful(row['inventoryCost']) ? row['inventoryCost'] : 0
        }
        if(this.params.type === 'msku'){
          param = {
            warehouseId:row.warehouseId,
            msku:row.msku,
            monthDate: row.monthDate,
            ...param
          }
          batchUpdateFBAMonthCost([param]).then(() => this.$gjMessage.success('自动保存成功'))
        }else if(this.params.type === 'sku'){
          UpdateMonthCost(param).then(() => this.$gjMessage.success('自动保存成功'))
        }
      } else {
        this.$gjMessage.error('请输入正确的数值，保留四位小数');
      }
    },
    $gjQuery() {
      this.loading = true;
      const params = {
        model: {
          monthDateEnd: convertToFullDate(this.dateVal[1], 'yyyy-MM'),
          monthDateStart: convertToFullDate(this.dateVal[0], 'yyyy-MM'),
          ...this.params
        },
        ...this.queryPagination,
      };
      getHistoryMonthCostPage(params)
          .then((data) => {
            this.tableData = data.records;
            this.tableData.forEach(item=>{
              if(!item.purchaseCost && !item.inventoryCost){
                item.updateTime = null;
              }
            })
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
    },
    confirm() {
      this.$emit('updated');
    }
  }
}
</script>

<style scoped>
.cost-history-content {
  padding: 0 10px 0 20px;
  flex-direction: column;
}

.cost-history-title {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}

.cost-history-info {
  width: 100%;
  margin-bottom: 8px;
  font-size: 12px;
  color: #666;;
}

.cost-history-label {
  display: inline-block;
  text-align: right;
  margin-right: 10px;
}
.gj-inline-text{
  margin-left: 10px;
  display: inline-block;
  line-height: 22px;
  text-align: center;
  width: 68px;
  height: 20px;
  border-radius: 6px;

}
.gj-w{
  color: #666666;
  border: 1px solid #CED0D5;
  background: #EFF1F3;
}
.gj-s{
  color: #ED8004;
  border: 1px solid #F69C13;
  background: #FDEBD0;
}
.gj-x{
  color: #1F6EEF;
  background: rgba(167, 212, 255, 0.4);
  border: 1px solid #168FFE;
}
</style>
